/**
 * お知らせ設定ページ用のスクリプト
 */
 if (is_route('information.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        information_event_set();
        information_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.information_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).off('click', '[data-setting-modal]');
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], false, function(results) {
            information_setting_event_set();
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        $('#nformation-setting-modal .errors').each(function() {
            $(this).toggleClass('d-none', true);
        });
        _modal.submit(this, 'save-modal', null, function(xhr) {
            if (xhr.responseJSON == null) {
                xhr.responseJSON = JSON.parse(xhr.responseText);
            }
            $.each(xhr.responseJSON.errors, function(name, message) {
                $("#information-setting-modal-" + name + "-errors").show();
            });
        });
    });
}
/**
 * 設定モーダル表示時のイベント設定
 */
window.information_setting_event_set = function () {

    function setDisplayOfValueInput(elm)
    {
        // スイッチによる制御対象のinputを配列化し取得
        const targets = ($(elm).data('target').indexOf(',') >= 0) ? 
            $(elm).data('target').split(',') : [$(elm).data('target')];
        // 表示可否のフラグ
        const isDisplay = Number($(elm).val()) == 1;
        // 対象のインプットの制御
        $.each(targets, function(i, target) {
            const input = $('input[name=' + target + ']');
            const id = $(input).attr('id');
            // inputの有効/無効化
            $(input).prop('disabled', !isDisplay);
            // inputがhiddenでない場合
            if ($(input).attr('type') != 'hidden') {
                // 表示/非表示
                $(input).toggleClass('display-none', !isDisplay);
                $('label[for=' + id + ']').toggleClass('display-none', !isDisplay);
                // 値が未指定の場合は初期値を付与
                if ($(input).val() == '') {
                    $(input).val($(input).data('default'));
                }
            }
        });
    }
    // input切り替え用のnameを取得
    let switchNames = [];
    $('.information_item_flag').each(function () {
        // 重複を回避して登録
        if (switchNames.indexOf($(this).attr('name')) == -1) {
            switchNames.push($(this).attr('name'));
        }
    });
    // 取得したnameにイベントをセット
    $.each(switchNames, function(i, name) {
        // スイッチの変更時
        $(document).off('change', 'input[name=' + name + ']');
        $(document).on('change', 'input[name=' + name + ']', function() {
            setDisplayOfValueInput(this);
        });
        // 初期値用
        setDisplayOfValueInput($('input[name=' + name + ']:checked'));
    });

}
